import { mutateGrades } from "@/api/grade/useGradesQuery";
import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/Alert";
import { handleErrorResponse } from "@/utils/errorMessage";
import { validateFormValues } from "@/utils/validation";
import styled from "@emotion/styled";
import { Box, Button, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { MasterApiGradesGradeIdPutRequest } from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function GradeUpdateForm(params: { formatterProps: any }) {
  const { closeModal } = useModal();
  const { formatterProps } = params;
  const queryClient = useQueryClient();
  const { mutate: updateMutate } = useMutation(
    (params: MasterApiGradesGradeIdPutRequest) =>
      mutateGrades.update(params).mutationFn(params as MasterApiGradesGradeIdPutRequest | any),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["grades"]);
        closeModal(formatterProps);
        customAlert("Grade 수정에 성공하였습니다.", "수정 성공", "green");
      },
      onError: (error) => {
        customAlert(
          handleErrorResponse({ error, errorContext: "Grade 코드" }),
          "Grade 수정 실패",
          "red",
        );
      },
    },
  );
  const form = useForm({
    initialValues: {
      code: formatterProps.code,
      name: formatterProps.name,
    },
  });

  const onSubmit = async () => {
    try {
      updateMutate({
        gradeId: formatterProps.id as number,
        gradesGetRequest: {
          code: form.values.code as any,
          name: form.values.name as any,
        },
      });
    } catch (error) {
      customAlert(
        handleErrorResponse({ error, errorContext: "Grade 코드" }),
        "Grade 수정 실패",
        "red",
      );
    }
  };

  return (
    <Box maw={320} mx="auto">
      <Form>
        <ModalFieldSet>
          <TextInput
            label="Grade코드"
            withAsterisk
            {...form.getInputProps("code")}
            defaultValue={formatterProps.code}
            error={form.isDirty("code") ? "저장 필요" : ""}
            styles={{
              input: {
                color: form.isDirty("code") ? "red !important" : "",
                borderColor: form.isDirty("code") ? "red !important" : "",
              },
              error: { fontSize: 11, color: "red" },
            }}
          />
          <TextInput
            label="Grade명"
            withAsterisk
            {...form.getInputProps("name")}
            defaultValue={formatterProps.name}
            error={form.isDirty("name") ? "저장 필요" : ""}
            styles={{
              input: {
                color: form.isDirty("name") ? "red !important" : "",
                borderColor: form.isDirty("name") ? "red !important" : "",
              },
              error: { fontSize: 11, color: "red" },
            }}
          />
          <ModalConfirmBtnBox>
            <Button color="gray" onClick={closeModal}>
              취소
            </Button>
            <Button
              disabled={validateFormValues({
                pageType: "grade",
                values: form.values,
              })}
              onClick={onSubmit}
            >
              Grade 수정
            </Button>
          </ModalConfirmBtnBox>
        </ModalFieldSet>
      </Form>
    </Box>
  );
}

const Form = styled.form`
  width: 100%;
  height: 100%;
`;

const ModalFieldSet = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ModalConfirmBtnBox = styled.div`
  padding: 24px 0;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  // & button {
  //   width: 54px;
  //   height: 40px;
  //   border-radius: 4px;
  //   &.cancel_btn {
  //     background-color: white;
  //   }
  // }
`;
